<template>
  <section class="self_sec"> 
    <div class="container-fluid">
      <div class="logout_window">
        <div class="card">
          <h4>
            You have been logged out. You can close this window.
          </h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "SSOLogout",
};
</script>
